"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Содержит методы для формирования запроса к API.
 */
var RequestHelper = /** @class */ (function () {
    function RequestHelper() {
    }
    /**
     * Создаёт заголовки запроса к API из указанной коллекции значений.
     * @param values Коллекция значений.
     */
    RequestHelper.createHeaders = function (values) {
        var keys = Object.keys(values);
        var length = keys.length;
        var headers = {};
        for (var i = 0; i < length; i += 1) {
            var key = keys[i];
            var value = values[key];
            if (value != null) {
                headers[key] =
                    typeof value === 'boolean' ? String(Number(value)) : String(value);
            }
        }
        return headers;
    };
    /**
     * Создаёт тело запроса к API из указанной коллекции значений.
     * @param values Коллекция значений.
     */
    RequestHelper.createBody = function (values) {
        var body = {};
        var keys = Object.keys(values);
        var length = keys.length;
        for (var i = 0; i < length; i += 1) {
            var key = keys[i];
            var value = values[key];
            if (value == null) {
                body[key] = null;
            }
            else {
                body[key] = typeof value === 'boolean' ? Number(value) : value;
            }
        }
        return JSON.stringify(body);
    };
    /**
     * Преобразует указанную дату и время в строку, пригодную для отправки в API.
     * @param time Дата и время.
     * @returns
     */
    RequestHelper.formatTime = function (time) {
        var stringify = function (value) {
            return value < 10 ? "0" + value : String(value);
        };
        var year = stringify(time.getFullYear());
        var month = stringify(time.getMonth() + 1);
        var days = stringify(time.getDate());
        var hours = stringify(time.getHours());
        var minutes = stringify(time.getMinutes());
        var seconds = stringify(time.getSeconds());
        return year + "-" + month + "-" + days + " " + hours + ":" + minutes + ":" + seconds;
    };
    /**
     * Преобразует смещенение относительно Гринвича (в часах) в строку, пригодную
     * для отправки в API.
     * @param offset Смещение (в часах) относительно нулевого меридиана.
     * @returns
     */
    RequestHelper.formatTimezone = function (offset) {
        var sign = offset >= 0 ? '+' : '';
        return "GMT" + sign + offset;
    };
    return RequestHelper;
}());
exports.default = RequestHelper;
